import React, { useCallback, useRef, useState } from 'react';
import './keno.scss';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { PossibleOdd } from './lastResults';
import { NumberItem } from './numberItem';
import { WinPopup } from './winPopup';
import { kenoBetStore } from '../../store/kenoBetStore';
import { KenoNumbers } from '../../core/constants/kenoNumbers';
import { KenoIncludedNumbers } from '../../core/constants/kenoIncludedNumbers';

const Keno = observer(() => {
  const {
    selectedNumbers,
    updateSelectedNumbers,
    isBetsClosed,
    winNumbers,
    hotNumbers,
    coldNumbers,
  } = kenoBetStore;
  const ref = useRef();
  const [selectedData, setSelectedData] = useState([]);

  const handleSelectNumber = useCallback(
    (e) => {
      if (!isBetsClosed) {
        const valueType = e.target.dataset.type;
        const model = KenoIncludedNumbers[valueType];
        if (model?.numbers) {
          updateSelectedNumbers(model.numbers);
        }
      }
    },
    [updateSelectedNumbers, isBetsClosed]
  );

  const handleMouseMove = useCallback(
    (e) => {
      if (!ref.current.contains(e.target)) {
        setSelectedData([]);
      } else {
        if (!e.target || isMobile()) {
          return;
        }
        const valueType = e.target.dataset.type;
        const model = KenoIncludedNumbers[valueType];
        setSelectedData(model?.numbers || []);
      }
    },
    [ref]
  );

  return (
    <div className='keno-game-block'>
      <div className='keno-game-content'>
        <PossibleOdd />
        <div className='keno-game'>
          <div
            className='keno-numbers-list'
            onMouseMove={isMobile() ? null : handleMouseMove}
            ref={ref}
            onMouseLeave={isMobile() ? null : () => setSelectedData([])}
            onClick={(e) => handleSelectNumber(e)}
          >
            {KenoNumbers.map(({ number, right, bottom, center, self }) => {
              return (
                <NumberItem
                  self={self}
                  key={number}
                  right={right}
                  bottom={bottom}
                  center={center}
                  number={number}
                  winNumbers={winNumbers}
                  selectedData={selectedData}
                  isCold={coldNumbers.includes(String(number))}
                  isHot={hotNumbers.includes(String(number))}
                  isSelected={selectedNumbers.includes(number)}
                />
              );
            })}
            {!isMobile() ? <WinPopup /> : null}
          </div>
        </div>
      </div>
    </div>
  );
});

export default Keno;
